module.exports = __webpack_public_path__ + "c6f17644d5aa2f0a4d51a0ffbf9546db.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GN.svg
// module id = pZyC
// module chunks = 0